export const COLOR_NAME_TO_HEX = {
    black: '#000000',
    white: '#FFFFFF',
    grey: '#808080',
    gray: '#808080',
    silver: '#C0C0C0',
    blue: '#0000FF',
    navy: '#000080',
    red: '#FF0000',
    green: '#008000',
    brown: '#A52A2A',
    beige: '#F5F5DC',
    sand: '#C2B280',
}

export const HEX_COLOR_PREFERRED_KEYS = [
    'hexColour',
    'hexColor',
    'hexcolour',
    'hexcolor',
    'c_hexColour',
    'c_hexColor',
    'c_hexcolour',
    'c_hexcolor',
]
